angular.module('unergie.main')
.controller('prmSearchModalCtrl', ($scope, $timeout, $uibModalInstance, ApiUser, AlertManager,
    ReferencesService, NgTableParams, AuthService, BoFeaturesService, ErrorCatcher, light) => {
    $scope.light = light
    $scope.providerName = BoFeaturesService.get('providerLabel')
    $scope.accessSge = BoFeaturesService.isFeatureOn('accessSge')
    $scope.canSelectPRMOutOfPerimeter = BoFeaturesService.isFeatureOn('canSelectPRMOutOfPerimeter')

    $scope.addressTooltip = `Ce champ de recherche s'appuie sur le référentiel national des adresses ` +
        `(adresse.data.gouv.fr). Si les adresses du référentiel Enedis ne sont pas à jour, modifier les champs ci-dessous pour retrouver le PDL.`

    ReferencesService.getRef('inseepostcode', true).then((mapping) => {
        $scope.codes = mapping
    })

    $scope.close = $uibModalInstance.dismiss
    $scope.searching = false

    // TECHNICAL INFO
    $scope.availableTensions = [
        { label: '', value: undefined },
        { label: 'BT<=36kVA', value: 'BTINF' },
        { label: 'BT>36kVA', value: 'BTSUP' },
        { label: 'HTA', value: 'HTA' },
    ]

    $scope.clientTypes = [
        { label: '', value: '' },
        { label: 'Résidentiel', value: 'PART' },
        { label: 'Professionel', value: 'PRO' },
    ]

    $scope.search = {}

    $scope.reset = function () {
        $scope.addressSearch = undefined
        $scope.commune = undefined
        $scope.addrResult = []
        $scope.search.power_kind = undefined
        $scope.search.meter_number = undefined
        $scope.search.client = {}
        $scope.search.client.category = undefined
        $scope.search.client.name = undefined
        $scope.search.client.siret = undefined
        $scope.search.address = {}
        $scope.search.address.num_street = undefined
        $scope.search.address.detail = undefined
        $scope.search.address.city = {}
        $scope.search.address.city.post_code = undefined
        $scope.search.address.city.city_code = undefined
        $scope.coordinates = undefined
    }

    $scope.reset()

    // ADDRESS
    $scope.updateAddr = function (data) {
        const insee = _.find($scope.codes, { postcode: data.addr_post_code, insee_code: data.addr_city_code })
        if (insee) {
            $scope.commune = `${insee.postcode} - ${insee.township}`
            $scope.search.address.city.post_code = insee.postcode
            $scope.search.address.city.city_code = insee.insee_code
        } else {
            $scope.commune = `${data.addr_post_code} - ${data.addr_city_lbl.toUpperCase()}`
            $scope.search.address.city.post_code = data.addr_post_code
            $scope.search.address.city.city_code = data.addr_city_code
        }
        $scope.search.address.num_street = data.addr_num_street
        $scope.coordinates = { x: data.addr_x, y: data.addr_y }
        return $scope.checkInsee()
    }

    $scope.lookupAddr = function (addr) {
        $scope.coordinates = undefined
        $scope.searching = true
        const p = ApiUser.lookupAddr({ q: addr }).$promise
        p.then(() => {
            $scope.searching = false
        }).catch(() => {
            $scope.searching = false
        })
        return p
    }

    $scope.checkInsee = function (commune) {
        if (commune) {
            $scope.search.address.city.post_code = commune.postcode
            $scope.search.address.city.city_code = commune.insee_code
        }
        $scope.inseeCodeOk = undefined
        const citycode = $scope.search.address.city.city_code
        return ApiUser.eligibilityGeo({ id: citycode }).$promise.then((eliResult) => {
            const eligible = !!eliResult.eligible
            $scope.inseeCodeOk = eligible
            $scope.inseeCodeMessage = `Le code INSEE ${citycode} ${eligible ? 'est' : "n'est pas"} desservi par Enedis`
        }).catch((error) => {
            $scope.inseeCodeOk = false
            return ErrorCatcher(error)
        })
    }

    // SEARCH
    $scope.canSearch = () => !!($scope.search.client.siret || ($scope.search.address.city.post_code && $scope.search.address.city.city_code)) &&
        (!$scope.search.client.name || $scope.search.client.name.length >= 3)

    const cleanEmpty = (obj) =>
        _.forEach(obj, (value, key) => {
            if (angular.isObject(value)) {
                return cleanEmpty(value)
            } else if ((value === null) || (value === '') || (value === undefined)) {
                return delete obj[key]
            }
        })

    $scope.searchPrm = function (v = 2) {
        cleanEmpty($scope.search)
        const automaticOutOfPerimeter = !$scope.canSelectPRMOutOfPerimeter
        $scope.searchingPrm = true
        return ApiUser.lookupPrm({ v, automaticOutOfPerimeter }, $scope.search).$promise.then((data) => {
            AlertManager.success(`${data.length} resultat${data.length > 1 ? 's' : ''} trouvé${data.length > 1 ? 's' : ''}.`)
            _.forEach(data, (d) => {
                d.address.full = `${d.address.num_street} - ${d.address.city}${d.address.place ? (` (${d.address.place})`) : ''}`
            })
            $scope.tableParams = new NgTableParams({
                page: 1,
                count: ($scope.tableParams != null ? $scope.tableParams.count() : undefined) || 5,
                filter: ($scope.tableParams != null ? $scope.tableParams.filter() : undefined) || {},
                sorting: ($scope.tableParams != null ? $scope.tableParams.sorting() : undefined) || {},
            }, { counts: [], dataset: data })
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.searchingPrm = false
        })
    }

    // CHOOSE PRM
    $scope.choosePRM = (datum) => $uibModalInstance.close(datum.prm)
})
